import React, { useContext, useEffect, useState } from 'react';
import { plotDossiersApi } from '../../api/plotDossiers';
import { frameworksApi } from '../../api/frameworks';
import EngagementMessageContext from '../../context/EngagementMessageContext';
import { explainerLinkFrom, frameworkOfferVisible } from '../../utils/frameworkOffer';

/**
 * Link that opens the published Framework explainer in the message pop-up.
 * Hidden until the readiness rule is met, and hidden when no explainer
 * is published. The one-line definition stays with the Framework title.
 */
export default function FrameworkExplainerLink({ storyId, hasFramework = false }) {
  const openOnDemand = useContext(EngagementMessageContext)?.openOnDemand;
  const [explainer, setExplainer] = useState(null);

  useEffect(() => {
    if (!storyId || hasFramework) {
      setExplainer(null);
      return undefined;
    }
    if (typeof plotDossiersApi.plotReady !== 'function') return undefined;
    if (typeof frameworksApi.latestExplainer !== 'function') return undefined;
    let cancelled = false;
    (async () => {
      try {
        const view = await plotDossiersApi.plotReady(storyId);
        const ready = frameworkOfferVisible({
          ready: view?.enough_solid === true,
          hasFramework: false,
        });
        if (!ready) {
          if (!cancelled) setExplainer(null);
          return;
        }
        const found = await frameworksApi.latestExplainer();
        if (cancelled) return;
        setExplainer(explainerLinkFrom(found));
      } catch {
        if (!cancelled) setExplainer(null);
      }
    })();
    return () => { cancelled = true; };
  }, [storyId, hasFramework]);

  if (!explainer) return null;

  return (
    <button
      type="button"
      className="fw-offer__link"
      data-testid="framework-explainer-link"
      onClick={() => {
        if (typeof openOnDemand === 'function') openOnDemand(explainer.id);
      }}
    >
      {explainer.title}
    </button>
  );
}
